import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
  Alert
} from 'reactstrap';
import LabelInput from '@src/components/LabelInput/LabelInput';
import {
  required,
  email,
  maxLength,
  passwordCompare,
  passwordLength
} from '@src/validation';
import ProgressBox from '@src/components/ProgressBox/ProgressBox';

const createValidator = {
  email: [required, email, value => maxLength(value, 255)],
  name: [required, value => maxLength(value, 255)],
  role: [value => maxLength(value, 64)],
  password: [required, passwordLength],
  repassword: [required, passwordLength]
};

const editValidator = {
  email: [required, email, value => maxLength(value, 255)],
  name: [required, value => maxLength(value, 255)],
  role: [required],
  status: [required]
};
class UserModal extends React.Component {
  constructor(props) {
    super(props);
    const fields = {};

    const validator =
      props.entity.id === undefined ? createValidator : editValidator;
    Object.keys(validator).forEach(key => {
      fields[key] = {
        value:
          props.entity[key] !== undefined && props.entity[key] !== null
            ? props.entity[key]
            : key === 'role'
            ? 'STAFF'
            : '',
        visited: false,
        error: false
      };
    });

    this.state = { ...fields, validator: validator };
  }

  updateForm = (event, name) => {
    const inputData = {
      value: event.target.value,
      visited: true,
      error: false
    };

    for (let i = 0; i < this.state.validator[name].length; i++) {
      const validationMsg = this.state.validator[name][i](inputData.value);
      if (validationMsg !== undefined) {
        inputData.error = validationMsg;
        break;
      }
    }
    if (name === 'repassword' && inputData.error === false) {
      let validationPass = passwordCompare(
        inputData.value,
        this.state.password.value
      );
      if (validationPass !== undefined) {
        inputData.error = validationPass;
      }
    }

    this.setState({
      [name]: inputData
    });
  };

  submitHandler = e => {
    e.preventDefault();
    const formData = JSON.parse(JSON.stringify(this.state));
    const postData = {};
    let isValid = true;

    Object.keys(this.state.validator).forEach(key => {
      postData[key] = formData[key].value;
      for (let i = 0; i < this.state.validator[key].length; i++) {
        const validationMsg = this.state.validator[key][i](formData[key].value);
        formData[key].visited = true;
        if (validationMsg !== undefined) {
          formData[key].error = validationMsg;
          isValid = false;
          break;
        } else {
          formData[key].error = false;
        }
      }

      if (key === 'repassword' && formData[key].error === false) {
        let validationPass = passwordCompare(
          formData[key].value,
          this.state.password.value
        );
        if (validationPass !== undefined) {
          formData[key].error = validationPass;
          isValid = false;
        }
      }
    });

    this.setState({ ...formData });

    if (isValid) {
      this.props.onSubmit(postData);
    }
    return false;
  };

  render = () => {
    return (
      <Modal
        isOpen={this.props.isActive}
        toggle={this.props.toggle}
        className={this.props.className}
      >
        <form
          ref={c => {
            this.form = c;
          }}
          onSubmit={this.submitHandler.bind(this)}
        >
          <ModalHeader toggle={this.props.toggle}>
            {this.props.entity.id !== undefined ? 'Edit User' : 'Create User'}
          </ModalHeader>
          <div className={'position-relative'}>
            {this.props.loading && <ProgressBox text={'Submiting ...'} />}
            <ModalBody className={'p-4'}>
              <Row>
                <Col>
                  {this.props.error !== false && (
                    <Alert color={'danger'}>{this.props.error}</Alert>
                  )}
                  <LabelInput
                    name={'Email'}
                    type={'email'}
                    required={true}
                    {...this.state.email}
                    onChange={event => this.updateForm(event, 'email')}
                  />
                  <LabelInput
                    name={'Name'}
                    type={'text'}
                    required={true}
                    {...this.state.name}
                    onChange={event => this.updateForm(event, 'name')}
                  />
                  <div className={'form-group'}>
                    <span className={'font-weight-bold'}>Role</span>
                    <select
                      className={'form-control'}
                      value={this.state.role.value}
                      onChange={event => this.updateForm(event, 'role')}
                    >
                      <option value={'STAFF'}>Staff</option>
                      <option value={'ADMIN'}>Admin</option>
                    </select>
                  </div>

                  {this.props.entity.id === undefined && (
                    <div>
                      <LabelInput
                        name={'Password'}
                        type={'password'}
                        required={true}
                        {...this.state.password}
                        onChange={event => this.updateForm(event, 'password')}
                      />
                      <LabelInput
                        name={'Confirm Password'}
                        type={'password'}
                        required={true}
                        {...this.state.repassword}
                        onChange={event => this.updateForm(event, 'repassword')}
                      />
                    </div>
                  )}
                  {this.props.entity.id !== undefined && (
                    <div className={'form-group'}>
                      <span className={'font-weight-bold'}>Status</span>
                      <select
                        className={'form-control'}
                        value={this.state.status.value}
                        onChange={event => this.updateForm(event, 'status')}
                      >
                        <option value={1}>Active</option>
                        <option value={0}>Inactive</option>
                      </select>
                    </div>
                  )}
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter className={'py-4'}>
              <Button color="primary" className={'btn px-3'} type={'submit'}>
                Save
              </Button>
            </ModalFooter>
          </div>
        </form>
      </Modal>
    );
  };
}

export default UserModal;
